import { AsyncHotelFilter } from '@new/__global/components/AsyncHotelFilter'
import { formatDateRange, parseDateRange } from '@new/__global/components/FastTapeChart/__utils'
import { OperationStatusFilter } from '@new/__global/components/FastTapeChart/components/TapeChartFilters/OperationStatusFilter'
import {
  amenitiesFilter,
  arrivalsModeFilter,
  availableDatesFilter,
  bathroomsRangeFilter,
  bedroomsRangeFilter,
  colorByFilter,
  CustomFilterIds,
  nightlyRatesFilter,
  occupancyRangeFilter,
  viewFromFilter,
  ViewStateFilterIds,
} from '@new/__global/components/FastTapeChart/config/filtersConfig'
import { FilterConfig } from '@new/__global/components/FiltersFramework'
import {
  arrayParamsFormatterAndParser,
  booleanParamParser,
  stringParamParser,
} from '@new/__global/components/FiltersFramework/_utils'
import { parseDateRangeParam } from '@new/domains/fastBookingsTapeChart/__utils'
import { CheckInDatesFilter } from '@new/domains/fastBookingsTapeChart/components/TapeChartFilters/CheckInDatesFilter'
import { GroupByRoomType } from '@new/domains/hotelTapeChart/components/GroupByRoomType'
import { HotelOmniSearch } from '@new/domains/hotelTapeChart/components/HotelOmniSearch'
import { UnassignedBookingsFilter } from '@new/domains/hotelTapeChart/components/UnassignedBookingsFilter'
import { UnitsSortingSelect } from '@new/domains/hotelTapeChart/components/UnitsSortingSelect'
import {
  DEFAULT_HOTEL_ID,
  UnassignedBookingsView,
  UnitsSorting,
} from '@new/domains/hotelTapeChart/config/contants'

export enum HotelFilterIds {
  HotelId = 'hotelId',
  HotelSearch = 'hotelSearch',
  RoomType = 'roomType',
  UnassignedBookings = 'unassignedBookings',
}

export enum UnitFilterIds {
  OperationReadinessStatus = 'operationReadinessStatus',
}

export enum SortingFilterIds {
  GroupByRoomType = 'groupByRoomType',
  SortUnitsBy = 'sortUnitsBy',
}

export const hotelTapeChartFiltersConfig: FilterConfig<any>[] = [
  {
    id: HotelFilterIds.HotelId,
    label: 'Hotel',
    queryParamName: 'hotel-id',
    ...stringParamParser,
    showOnTheTopFiltersBar: () => true,
    component: props => <AsyncHotelFilter.Select {...props} />,
    defaultValue: DEFAULT_HOTEL_ID,
  },
  {
    id: HotelFilterIds.HotelSearch,
    label: 'Search',
    queryParamName: 'term',
    showOnTheTopFiltersBar: () => false,
    showOnTheSidePanel: () => true,
    showOnTheAppliedFilters: () => false,
    component: () => <HotelOmniSearch />,
  },
  {
    id: HotelFilterIds.RoomType,
    label: 'RoomType',
    queryParamName: 'room-type-id',
    ...stringParamParser,
    showOnTheTopFiltersBar: () => false,
    showOnTheSidePanel: () => false,
    showOnTheAppliedFilters: () => false,
    component: () => null,
  },
  viewFromFilter,
  {
    ...availableDatesFilter,
    showOnTheTopFiltersBar: () => false,
    showOnTheSidePanel: () => false,
    showOnTheAppliedFilters: () => false,
  },
  nightlyRatesFilter,
  colorByFilter,
  arrivalsModeFilter,
  occupancyRangeFilter,
  bedroomsRangeFilter,
  bathroomsRangeFilter,
  amenitiesFilter,
  {
    id: UnitFilterIds.OperationReadinessStatus,
    label: 'Operation Status',
    queryParamName: 'operation-readiness-status',
    ...arrayParamsFormatterAndParser,
    component: props => <OperationStatusFilter {...props} />,
    showOnTheTopFiltersBar: () => false,
    showOnTheSidePanel: () => false,
    showOnTheAppliedFilters: () => true,
  },
  {
    id: HotelFilterIds.UnassignedBookings,
    label: 'Unassigned Bookings',
    queryParamName: 'unassigned-bookings',
    ...stringParamParser,
    defaultValue: UnassignedBookingsView.Disabled,
    showOnTheTopFiltersBar: () => false,
    showOnTheSidePanel: () => false,
    showOnTheAppliedFilters: () => false,
    component: UnassignedBookingsFilter,
  },
  {
    id: CustomFilterIds.CheckInExistsBetween,
    label: 'Check-In Date',
    queryParamName: 'check-in-between',
    showOnTheTopFiltersBar: () => false,
    parser: parseDateRange,
    filterPreviewFormatter: parseDateRangeParam,
    formatter: formatDateRange,
    component: CheckInDatesFilter,
  },
  {
    id: SortingFilterIds.GroupByRoomType,
    label: 'Group by Room Type',
    queryParamName: 'group-by-room-type',
    showOnTheTopFiltersBar: () => false,
    showOnTheSidePanel: () => false,
    showOnTheAppliedFilters: () => false,
    component: GroupByRoomType,
  },
  {
    id: SortingFilterIds.SortUnitsBy,
    label: 'Sort Units By',
    queryParamName: 'sort-units-by',
    defaultValue: UnitsSorting.RANK,
    showOnTheTopFiltersBar: () => false,
    showOnTheSidePanel: () => false,
    showOnTheAppliedFilters: () => false,
    component: UnitsSortingSelect,
  },
  {
    id: ViewStateFilterIds.DebugRevenueScore,
    label: 'Debug Revenue Score',
    queryParamName: 'debug-revenue-score',
    ...booleanParamParser,
    showOnTheTopFiltersBar: () => false,
    showOnTheSidePanel: () => false,
    showOnTheAppliedFilters: () => false,
  },
]
